import { maxLengthRule, requiredRule } from './main.js';
import { name as nameValidator } from '@/common/validators.js';
import { helpers } from '@vuelidate/validators';

const defaultOptions = {
    cyrillic: false,
    required: true,
};

export function nameRulesDefault(options = defaultOptions) {
    const { cyrillic, required } = { ...defaultOptions, ...options };

    const rules = {
        name: helpers.withMessage('Имя содержит недопустимые символы', nameValidator),
        ...requiredRule(),
        ...maxLengthRule(),
    };

    if (!cyrillic)
        rules.name = true;

    if (!required)
        rules.required = true;

    return rules;
}
